<template>
  <div class="item">
    <div class="informations" @click="click">
      <span class="information_name">{{ room.session_name }}</span>
      <span class="information_date">{{ dateFormated }}</span>
    </div>
    <div class="button-block">
      <CopyClipboardButton copyFrom="RoomLive" :copy="link" />
      <v-btn text class="button-item" @click.stop="openSendEmailDialog">
        <v-icon>mail_outline</v-icon>
      </v-btn>
      <SendEmailDialog
        v-if="true"
        v-model="showScheduleForm"
        from="LiveRooms"
        :username="username"
        :userEmail="userEmail"
        :initialObjectValue="objectValue"
        :initialText="initialText"
        :videoId="room.id_live_video"
      >
      </SendEmailDialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import SendEmailDialog from '@/components/SendEmailDialog'
import CopyClipboardButton from '@/components/buttons/CopyClipboardButton'

import { formatHourWithLanguage } from '@/script/dateAndHour'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ItemOfRooms',

  components: {
    CopyClipboardButton,
    SendEmailDialog
  },

  data: () => {
    return {
      showScheduleForm: false,
      show: false,
      objectValue: '',
      initialText: ''
    }
  },

  props: {
    room: Object
  },

  methods: {
    openSendEmailDialog() {
      this.initForm()
      this.showScheduleForm = true
    },
    click() {
      this.$router.push('/videos/live/rooms/' + this.room.id_live_video)
    },
    initForm() {
      this.objectValue = this.$t('rooms.email.object')

      const space = '\n\n'
      const backspace = '\n'
      const headMessage = this.$t('rooms.email.headMessage')
      const bodyMessage = this.$t('rooms.email.body')
      const bodyMessage2 = this.$t('rooms.email.body2')
      const endMessage = this.$t('rooms.email.endMessage')
      const date = this.$t('rooms.email.date') + this.date
      const hour = this.$t('rooms.email.heure') + this.hour
      const url = this.link

      this.initialText =
        headMessage +
        space +
        bodyMessage +
        backspace +
        date +
        backspace +
        hour +
        space +
        bodyMessage2 +
        backspace +
        url +
        space +
        endMessage
    }
  },

  computed: {
    ...mapGetters(['username', 'userEmail']),
    ...mapState({
      userOptions: (state) => state.userOptions
    }),
    accessEmailOptions() {
      const useStampothequeEmailAccess =
        this.userOptions && this.userOptions.find((el) => el.name === 'useStampothequeEmail')

      return (useStampothequeEmailAccess && useStampothequeEmailAccess.value) || false
    },
    date() {
      const locale = this.$i18n.locale

      return moment(this.room.appointment_date).locale(locale).format('dddd Do MMMM, YYYY')
    },
    hour() {
      return formatHourWithLanguage(this.room.appointment_date, this.$i18n.locale)
    },
    dateFormated() {
      return `${this.date} (${this.hour})`
    },
    link() {
      return document.location + '/' + this.room.id_live_video
    }
  }
}
</script>

<style lang="sass">
.item
  display: flex
  justify-content: space-between
  cursor: pointer
  transition: .3s all ease-in-out
  border-radius: 5px
  padding: 10px 20px
  background-color: rgba(0, 0, 0, 0)
  &:hover
    background-color: rgba(0, 0, 0, .1)
    transform: scale(1.1)
    box-shadow: 0 5px 25px rgba(0, 0, 0, .1)
.informations
  display: flex
  flex-direction: column
  width: 100%
.information_name
  font-size: 20px
  opacity: .8
  text-transform: uppercase
.information_date
  opacity: .6
.button-block
  display: flex
.button-item
  width: 50px
  height: 100% !important
  display: flex
  justify-content: center
  align-items: center
  &:hover > *
    color: var(--v-primary-darken1)
</style>
